module.exports = __webpack_public_path__ + "static/img/case_banner_05_h5.9ad6d6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_05_h5.png
// module id = bjrv
// module chunks = 34